import React from 'react';
import './404_page.css'

const NotFund_data_page = () => {
    return (
        <div className='container not_fund_oage'>
                <h2>Page Not Found</h2>
        </div>
    );
};

export default NotFund_data_page;